import { AppService } from "app/services/app.service";

import { TipoDocumentoAdmin } from "app/models/tipo-documento-admin.model";
import { Observable } from "rxjs";

export abstract class AbTipoDocumentoAdmin extends AppService {
  abstract getAllByLocal(local: string): Observable<any>;
  abstract getByIntegrador(): Observable<any>;
  abstract getByTenant(): Observable<any>;
  abstract getByTenantId(tenantId: number): Observable<any>;
  abstract getByPublicTenantId(tenantId: number): Observable<any>;
  abstract getLocale(): Observable<any>;
  abstract setCookieLocal(tipoDocumentos: Observable<Array<TipoDocumentoAdmin>>);
}